import React from 'react'
import { createBrowserHistory } from "history";
import { Router, Route, Switch,Link } from "react-router-dom";
import MainHome from '../containers/MainHome/MainHome.js'
import Project_info from '../containers/Project_info1/Project_info1'
import Product from "../containers/Product/Product";
import style from './RouterConfig.module.scss';
import intl from "react-intl-universal";
import search from "../image/temp/search.png";
import sample from "../containers/sample/sample";
import Privacypolicy from "../containers/Privacypolicy/Privacypolicy"
const locales = {
    "en-US": require('../locales/en-US.json'),
    "zh-CN": require('../locales/zh-CN.json'),
}

const hist = createBrowserHistory();
class RouterConfig extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            initDone:       false,
            anchorName:     "root",                         //定位锚点
            language:       "zh-CN",
            searchState:    false,                       //搜索状态
            firstNavState2:  [],

            firstNavState:  [{state:false},{state:false},{state:false},{state:false},{state:false}],
            firstNav:       [
                {title:"第一导航1",src:"/page1",childNav:[
                        {
                            title:"第二导航",
                            src:"/asd"
                        }
                    ],},
                {title:"第一导航2",src:"/page2",childNav:[
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        }
                    ],},
                {title:"第一导航3",src:"/page3",childNav:[
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        }, {
                            title:"第二导航",
                            src:"/asd"
                        }
                    ],},
                {title:"第一导航4",src:"/page1",childNav:[
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        }
                    ],},
                {title:"第一导航5",src:"/page1",childNav:[
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        },
                        {
                            title:"第二导航",
                            src:"/asd"
                        }
                    ],}
            ],
            navState:       false,
            banner:[
                {
                    src:        "../../image/temp/test.jpg"
                }

            ]
        };
    }
    //初始化函数（刚进入界面时候执行）
    componentDidMount() {
        localStorage.setItem("host","http://10.0.0.109:8081/api");

        this.loadLocales();
        /*this.SetFootSize();*/
    }
    SetFootSize=()=>{
        var r = document.documentElement;
        var a =parseInt(r.getBoundingClientRect().width);//获取当前设备的宽度
        var coefficient=a/100;
        var rem=a / coefficient.toFixed(2);
        console.log(a+"     "+rem);
        r.style.fontSize = rem + "px"


    }


    //初始化中英文
    loadLocales() {
        // react-intl-universal 是单例模式, 只应该实例化一次
        intl.init({
            currentLocale: 'zh-CN', // TODO: determine locale here
            locales,
        })
            .then(() => {
                this.setState({initDone: true});
            });
    }

    //切换中英文
    Changelanguage =(language)=>{
        if (language===this.state.language){
            return
        }
        else {
            this.setState({
                language:language
            })
            intl.init({
                currentLocale: language, // TODO: determine locale here
                locales,
            })
                .then(() => {
                    this.setState({initDone: true});
                });
        }

    }


    //logo跳首页
    link=(e)=>{
        window.location.href="/";
    }
    //开关导航栏
    handClick=(e)=>{
        console.log(this.state.navState);
        this.setState({
            navState:!this.state.navState
        })
    }
    //展开二级目录
    onMouseOut=(index)=>{
        var list=this.state.firstNavState;
        list[index].state=false;
        this.setState({
            firstNavState:list
        })
    }
    onMouseOver=(index)=>{
        var list=this.state.firstNavState;
        list[index].state=true;
        this.setState({
            firstNavState:list
        })
    }

    //搜索按钮
    search=()=>{
        if (!this.state.search){
            this.setState({
                searchState:true
            })
            return
        }
        this.setState({
            searchState:false
        })
    }

    render() {
        return (
            // this.state.initDone&&
            <Router history={hist}>
                {/*<div className={style.chooseLanguage}>
                    <div className={this.state.language==="zh-CN"?style.cn+" "+style.active:style.cn} onClick={(e)=>{this.Changelanguage("zh-CN")}}>中</div>
                    <div className={this.state.language==="en-US"?style.en+" "+style.active:style.en} onClick={(e)=>{this.Changelanguage("en-US")}}>EN</div>
                </div>*/}
                <div className={style.main}>
                    <Switch>
                        <Route path="/" exact component={MainHome}></Route>
                        <Route path="/Product/Project_info1/:projectid"  exact component={Project_info}></Route>
                        <Route path="/Product/:id" component={Product}></Route>
                        <Route path="/sample/" exact component={sample}></Route>
                        <Route path="/Privacypolicy/" exact component={Privacypolicy}></Route>
                        {/*<Route path="/home"  component={Home}></Route>*/}
                    </Switch>
                </div>

            </Router>)
    }
}

export default RouterConfig
